import { ANSICHTEN, anzeigeName, kuerzel, personFarbe, type Ansicht, type PersonZahl } from "./zusammenarbeit"

/**
 * Reiter über der Mail-Liste: Offen · Meine · Wartet · Alle.
 *
 * „Offen" ist dieselbe Liste, die das Review zeigt (Antworten + Aufgaben +
 * markierte) — Marlene soll im Mail-Programm arbeiten können, ohne für den
 * Überblick ins Review zu wechseln.
 *
 * Daneben ein Filter je Person (#198, Robin 19.10.2026): „Offen" zeigt nur
 * Mails ohne Zuständigen; wer eine Mail zugewiesen hat, findet sie bei der
 * Person. Die Chips kommen aus den tatsächlich vorkommenden Zuständigen.
 * Ist eine Person gewählt, ist kein Reiter aktiv.
 */
export function AnsichtReiter({ ansicht, setAnsicht, zahlen, personen, person, setPerson }: {
  ansicht: Ansicht
  setAnsicht: (a: Ansicht) => void
  zahlen?: Partial<Record<Ansicht, number>>
  personen?: PersonZahl[]
  person?: string | null
  setPerson?: (name: string | null) => void
}) {
  const aktiv = person ? undefined : ANSICHTEN.find((a) => a.key === ansicht)
  return (
    <>
    <div className="ev2-ansichten" role="tablist" aria-label="Ansicht">
      {ANSICHTEN.map((a) => {
        const aktiv = !person && a.key === ansicht
        const n = zahlen?.[a.key]
        return (
          <button
            key={a.key}
            type="button"
            role="tab"
            aria-selected={aktiv}
            title={a.titel}
            className={aktiv ? "ev2-ansicht aktiv" : "ev2-ansicht"}
            onClick={() => setAnsicht(a.key)}
          >
            {a.label}
            {typeof n === "number" && <span className="ev2-ansicht-zahl">{n}</span>}
          </button>
        )
      })}
      {setPerson && personen && personen.length > 0 && (
        <span className="ev2-personen" role="group" aria-label="Nach Person filtern" data-testid="personen-filter">
          {personen.map((p) => {
            const an = person === p.name
            return (
              <button
                key={p.name}
                type="button"
                aria-pressed={an}
                title={`Offene Mails von ${anzeigeName(p.name)} (${p.n})`}
                className={an ? "ev2-person-chip aktiv" : "ev2-person-chip"}
                onClick={() => setPerson(an ? null : p.name)}
              >
                <span className="ev2-person-punkt" style={{ background: personFarbe(p.name) }} aria-hidden>{kuerzel(p.name)}</span>
                {anzeigeName(p.name)}
                <span className="ev2-ansicht-zahl">{p.n}</span>
              </button>
            )
          })}
        </span>
      )}
    </div>
    {/* In Worten, was die Liste gerade zeigt — „Was bedeutet Wartet?" (14.10.) */}
    {aktiv && <div className="ev2-ansicht-erklaerung">{aktiv.titel}.</div>}
    {person && <div className="ev2-ansicht-erklaerung">Offene Mails von {anzeigeName(person)}.</div>}
    </>
  )
}
